module.exports = __webpack_public_path__ + "static/media/arrow-left.bed1564b.svg";